export function parseUnreadMessages(state, payload) {
  return payload.map((unreadMessage) => ({
    ...unreadMessage,
    notified: !!state.unread_messages.find((unreadMessageState) => unreadMessageState.id === unreadMessage.id),
  }))
}

export function parseAndNotify(state, payload) {
  return state.unread_messages.map((unreadMessage) => ({
    ...unreadMessage,
    notified: unreadMessage.id === payload.id ? true : unreadMessage.notified,
  }))
}
